import React from 'react';
import './style.css'
// import { Clock } from "lucide-react";
import one from '../../assests/icon/Pasted image (4).png'
import two from '../../assests/icon/Pasted image (5).png'
import three from '../../assests/icon/img-1.png'
import four from '../../assests/icon/Pasted image (3).png'
import five from '../../assests/icon/Pasted image (2).png'
import six from '../../assests/icon/icon1.png';
import { Link } from 'react-router-dom';
import social from './Social_media/1.png'
import social2 from './Social_media/2.png'
import social3 from './Social_media/3.png'
import social4 from './Social_media/4.png'
import social5 from './Social_media/5-img.png'
import social6 from './Social_media/6-img.png'
import social7 from './Social_media/7-img.png'
import social8 from './Social_media/8-img.png'
import social9 from './Social_media/9-img.png'
import social10 from './Social_media/10-img.png'
import social11 from './Social_media/11-img.png'
import social12 from './Social_media/12-img.png'
import aboutImg from '../../assests/blog/about.png'
import SEO from '../SEO';
const AboutSection = () => (
  <section className={`font-recoleta bg-black`}>
    <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-start text-white pt-[120px] px-[48px] pb-[60px] justify-items-center">
      {/* LEFT SIDE - Heading */}
      <div className="space-y-6 lg:mr-0 mr-12">
  <div className="space-y-4">
    <h2 className="text-[48px] 2xl:text-[40px] lg:text-[36px] font-black leading-[1.1] text-cyan-400">
      About Us
    </h2>

    <h3 className="text-white text-[40px] lg:text-[32px] 2xl:text-[28px] leading-10">
      Your Trusted IT Staff
      Augmentation &amp; Software Development
      Company
    </h3>
  </div>

  {/* IMAGE */}
  <div className="w-full max-w-[520px] overflow-hidden rounded-[24px] border border-white/10 shadow-2xl">
    <img
      src={aboutImg}
      alt="TekIT Team"
      className="w-full h-[320px] object-cover hover:scale-105 transition duration-500"
    />
  </div>
</div>

      {/* RIGHT SIDE - Paragraph + Button */}
      <div className="lg:space-y-6 lg:max-w-[360px]">
        <p className="text-white/70 lg:text-[18px] text-[36px]">
          TekIT is a global technology partner enabling businesses to build, scale, and optimize their digital
          capabilities. Whether you&#39;re building a product from scratch or scaling an existing team, TekIT acts as
          your extended tech arm — reliable, flexible, and performance-driven..
          We specialize in:
          <ul className="list-disc marker:text-cyan-400 pl-5 space-y-2 text-white/70 text-sm lg:text-base mt-4">
            <li>IT staff augmentation services</li>
            <li>Managed IT support services</li>
            <li>Custom software development services</li>
            <li>Web &amp; app development</li>
            <li>AI/ML development solutions</li>
          </ul>      </p>
        <Link
          to="/about-tekit"
          target=""
          rel="noopener"
          className="inline-flex items-center gap-2 px-6 py-3 border border-cyan-400 rounded-[14px] bg-[#FF2F00] shadow-[inset_0px_2px_1px_rgba(255,255,255,0.5),inset_0px_0.6px_0.6px_-1.25px_rgba(255,255,255,0.72),inset_0px_2.3px_2.3px_-2.5px_rgba(255,255,255,0.64),inset_0px_10px_10px_-3.75px_rgba(255,255,255,0.25),inset_0px_14px_6px_-8px_rgba(0,170,255,0.2)] hover:bg-[#e12700] transition duration-300 lg:mt-0 mt-6"
        >
          <div className="transform -rotate-[23deg] w-5 h-5">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 256 256"
              className="w-full h-full fill-white"
            >
              <path d="M221.66,133.66l-72,72a8,8,0,0,1-11.32-11.32L196.69,136H40a8,8,0,0,1,0-16H196.69L138.34,61.66a8,8,0,0,1,11.32-11.32l72,72A8,8,0,0,1,221.66,133.66Z" />
            </svg>
          </div>
          <span className="text-white font-medium text-[30px] lg:text-[18px]">Know More</span>
        </Link>
      </div>
    </div>
  </section>

);
const services = [
  {
    title: "IT Staff Augmentation",
    description: "Scale your team instantly with pre-vetted, production-ready developers. Skip months of hiring — get engineers who can start contributing from Day 1.",
    features: [
      "Pre-vetted global talent",
      "Flexible hiring models (hourly / monthly / dedicated teams)",
      "Fast onboarding (within days)",
      "Time-zone aligned collaboration",
      "Complete transparency & control",
    ],
    bestFor: "Startups, scaling teams, and enterprises needing speed without hiring overhead.",
    images: [social, social2],
  },
  {
    title: "Managed IT Support",
    description:
      "Our managed IT support services ensure your systems run smoothly, securely, and without interruptions.",
    features: [
      "24/7 monitoring & support",
      "Infrastructure & cloud management",
      "Security & compliance",
      "SLA-backed 4-hour response",
      "Performance optimization",
    ],
    images: [social3, social4],
    link: '/managed-services',
    extra:
      "With TekIT, you get proactive IT management that prevents downtime and maximizes productivity.",
  },
  {
    title: "Custom Software Development",
    description:
      "Build scalable, secure, and high-performance software tailored to your business. From idea to execution — we deliver end-to-end solutions.",
    features: [
      "SaaS product development",
      "Enterprise software solutions",
      "CRM & ERP systems",
      "API integrations",
      "Cloud-native applications",
    ],
    images: [social5, social6],
    extra:
      "We help businesses digitally transform with future-ready technology.",
  },
  {
    title: "Web Development",
    description:
      "We build high-performance, scalable, and SEO-optimized web platforms.",
    features: [
      "Business websites",
      "Enterprise portals",
      "E-commerce platforms",
      "Progressive Web Apps (PWAs)",
    ],
    images: [social9, social10],
    extra:
      "Optimized for performance, SEO, security, and scalability.",
  },
  {
    title: "Mobile App Development",
    description:
      "Create fast, intuitive, and scalable mobile experiences.",
    features: [
      "Native iOS & Android apps",
      "Cross-platform mobile apps",
      "Enterprise mobility solutions",
      "UI/UX-focused applications",
    ],
    images: [social11, social12],
    extra:
      "We focus on speed, user experience, and scalability.",
  },
  {
    title: "AI/ML Development",
    description:
      "Leverage data and automation to gain a competitive edge.",
    features: [
      "Machine learning model development",
      "Predictive analytics",
      "NLP solutions",
      "Computer vision",
      "AI-powered chatbots",
      "Business process automation",
    ],
    link: '/ai-ml-development',
    images: [social7, social8],
    extra:
      "We help businesses unlock data-driven insights.",
  },


];

const ServicesSection = () => (
  <section className="font-recoleta bg-black pt-[80px]">
  <h2 className="text-[64px] 2xl:text-[40px] lg:text-[36px] font-extrabold text-cyan-400 mb-12 text-center">
  Our Core Services
</h2>

    <div className="max-w-7xl bg-black p-6 grid lg:grid-cols-3 gap-6 justify-self-center">
      {services.map((service, index) => (
        <Link
          to={service.link}
          key={index}
          className="bg-[#171717] border border-[#292929] rounded-3xl p-6 h-[450px] flex flex-col shadow-[rgba(0,0,0,0.35)_-100px_1px_72px_0px] w-full transform rotate-1 overflow-hidden"
        >
          {/* 🔹 IMAGE SECTION (UNCHANGED LOGIC) */}
          <div className="relative mask-gradient mb-4 inline-block w-[240px] overflow-hidden">
            {service.images?.map((src, idx) => (
              <div
                key={idx}
                className={`absolute top-0 left-0 w-[92px] h-[92px] rounded-xl border-2 border-white border-opacity-30
                  ${idx === 0 ? "rotate-[-4deg] left-0 top-0 z-10" : ""}
                  ${idx === 1 ? "rotate-[4deg] left-[87px] top-0 z-20" : ""}
                  ${idx === 2 ? "rotate-[-4deg] left-[140px] top-0 z-30" : ""}
                  shadow-[rgba(0,0,0,0.33)_-0.7px_0px_0.7px]`}
              >
                <img
                  src={src}
                  alt="icon"
                  className="w-full h-full object-cover rounded-xl"
                />
              </div>
            ))}
            <div className="h-[92px]" />
          </div>

          <div className="flex flex-col flex-1  pr-2 ">
            <h3 className="text-white text-[18px] lg:text-[20px] font-semibold mb-2">
              {service.title}
            </h3>

            <p className="text-white/70 text-sm lg:text-base mb-2 leading-relaxed">
              {service.description}
            </p>

            {/* Features */}
            {service.features && (
              <ul className="list-disc pl-5 text-white/70 text-xs lg:text-sm space-y-1 mb-2">
                {service.features.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            )}

            {/* Extra */}
            {service.extra && (
              <p className="text-white/50 text-xs lg:text-sm italic pb-2">
                {service.extra}
              </p>
            )}
          </div>
        </Link>
      ))}
    </div>
  </section>
);

const cards = [
  {
    title: "Round-the-Clock Availability",
    description:
      "Our experts are available 24/7 for seamless execution and support.",
    background: six,
  },
  {
    title: "Highly Qualified &amp; Dedicated Team",
    description:
      "Certified developers with proven expertise across technologies.",
    background: two,
  },
  {
    title: "SLA – 4 Hour Response",
    description:
      "Rapid issue resolution guaranteed.",
    background: one,
  },
  {
    title: "Transparent Communication",
    description:
      "Real-time updates. No hidden surprises.",
    background: four,
  },
  {
    title: "Remote Onboarding & Global Talent Access",
    description:
      "No geographical limitations — hire top developers worldwide.",
    background: five,
  },
  {
    title: "Continuous Quality Evaluation",
    description:
      "Performance monitoring to maintain the highest delivery standards.",
    background: three,
  },

];

const ClaritySection = () => (
  <section className="bg-black text-white px-6 py-20 w-full font-recoleta">
    <div className="max-w-7xl mx-auto text-center">
      <h2 className="text-[64px] 2xl:text-[40px] lg:text-[36px] font-extrabold text-cyan-400 mb-4">Why TekIT is a Preferred IT Staff
Augmentation Company</h2>
      <p className='mb-12'>We don’t just provide developers — we deliver accountable, high-performing tech teams aligned with your business goals.</p>
      <div className="grid grid-cols-1  lg:grid-cols-3 lg:gap-6 gap-10">
        {cards.map((card, index) => (
          <div
            key={index}
            className="relative rounded-xl overflow-hidden shadow-[0_8px_30px_rgba(0,0,0,0.25)] group hover:scale-105 transition-transform duration-300 bg-gray-900"
          >
            <div className="flex justify-center items-center">
              <img
                src={card.background}
                alt={card.title}
                className="w-20 h-full py-6 object-contain "
              />
            </div>
            <div className="px-6 pb-4  flex flex-col gap-3">
              <h4 className="text-white font-semibold text-[40px] lg:text-[20px] 2xl:text-[24px]">
                {card.title}
              </h4>
              <p className="text-white/80 lg:text-[16px] 2xl:text-[18px] text-[36px]">
                {card.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

const HomePage = () => (
  <>
    <SEO
      title="Top Staff Augmentation & Custom Software Development Company | TekIT"
      description="TekIT Solution is a leading staff augmentation company & custom software development firm. Hire dedicated developers for web, mobile app, and AI projects."
      keywords="Staff Augmentation, Software Development, AI ML Development, Mobile App Development, Web Development"
      image="https://www.tekitsolution.com/og-image.jpg"
      url="https://www.tekitsolution.com/"
    />

    <main>
      <AboutSection />
      <ServicesSection />
      <ClaritySection />
    </main>
  </>
);

export default HomePage;
